import type { Project, Src, Dst } from "..";

export type UpdateIFDefinitionsGodRequest = {
  dfnSetVerNum: string;
  ifList?: UpdateIfListGod[];
};
export type UpdateIfListGod = {
  idx: Number;
  project?: Project;
  src?: Src;
  dst?: Dst;
};
